'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import keyMirror from 'react-utils/keyMirror';
import { getHasUserExceededEmbeddableVideoLimit, getAttemptedVideoUploadsCount, getEmbeddableVideoLimit, getUsedEmbeddableVideoCount } from 'FileManagerCore/selectors/Limits';
import { isOrWillVideoLimitBeReached } from 'FileManagerCore/utils/Limits';
import { getHasVideoIntegrationScope } from 'FileManagerCore/selectors/Auth';
import { confirmVideoUploadWithoutEmbed } from 'FileManagerCore/actions/Limits';
import Video2LimitReachedModal from '../components/modals/Video2LimitReachedModal';
import { getIsVideo2Enabled } from 'FileManagerCore/selectors/Video2OptInStatus';
import { jsx as _jsx } from "react/jsx-runtime";
const Modals = keyMirror({
  NONE: null,
  EMBEDDABLE_VIDEO: null
});
class LimitsModalsContainer extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      openModal: Modals.NONE
    };
    this.closeModal = () => {
      const {
        dispatchConfirmVideoUploadWithoutEmbed
      } = this.props;
      this.setState({
        openModal: Modals.NONE
      });
      dispatchConfirmVideoUploadWithoutEmbed();
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.attemptedVideoUploadsCount !== this.props.attemptedVideoUploadsCount) {
      if (this.getShouldShowVideoLimitModal()) {
        this.openEmbeddableVideoLimitModal();
      }
    }
  }
  openEmbeddableVideoLimitModal() {
    this.setState({
      openModal: Modals.EMBEDDABLE_VIDEO
    });
  }
  getHasExceededOrWillExceedVideoLimit() {
    const {
      hasUserExceededVideoLimit,
      attemptedVideoUploadsCount,
      quantityUsed,
      quantityAllowed
    } = this.props;
    return isOrWillVideoLimitBeReached({
      hasUserExceededVideoLimit,
      attemptedVideoUploadsCount,
      quantityUsed,
      quantityAllowed
    });
  }
  getShouldShowVideoLimitModal() {
    const {
      attemptedVideoUploadsCount,
      hasVideoIntegrationScope
    } = this.props;
    return attemptedVideoUploadsCount > 0 && hasVideoIntegrationScope && this.getHasExceededOrWillExceedVideoLimit();
  }
  render() {
    const {
      attemptedVideoUploadsCount,
      isUsingHubSpotVideo2,
      quantityUsed,
      quantityAllowed
    } = this.props;
    const {
      openModal
    } = this.state;
    if (openModal !== Modals.EMBEDDABLE_VIDEO || !isUsingHubSpotVideo2) {
      return null;
    }
    return /*#__PURE__*/_jsx(Video2LimitReachedModal, {
      videoCount: attemptedVideoUploadsCount,
      projectedNumber: quantityUsed + attemptedVideoUploadsCount,
      quantityAllowed: quantityAllowed,
      uploadingVideoCount: attemptedVideoUploadsCount,
      quantityUsed: quantityUsed,
      onClose: this.closeModal
    });
  }
}
LimitsModalsContainer.propTypes = {
  attemptedVideoUploadsCount: PropTypes.number.isRequired,
  quantityAllowed: PropTypes.number.isRequired,
  dispatchConfirmVideoUploadWithoutEmbed: PropTypes.func.isRequired,
  hasVideoIntegrationScope: PropTypes.bool.isRequired,
  hasUserExceededVideoLimit: PropTypes.bool.isRequired,
  quantityUsed: PropTypes.number.isRequired,
  isUsingHubSpotVideo2: PropTypes.bool.isRequired
};
const mapStateToProps = state => {
  return {
    isUsingHubSpotVideo2: getIsVideo2Enabled(state),
    attemptedVideoUploadsCount: getAttemptedVideoUploadsCount(state),
    hasVideoIntegrationScope: getHasVideoIntegrationScope(state),
    hasUserExceededVideoLimit: getHasUserExceededEmbeddableVideoLimit(state),
    quantityUsed: getUsedEmbeddableVideoCount(state),
    quantityAllowed: getEmbeddableVideoLimit(state)
  };
};
const mapDispatchToProps = {
  dispatchConfirmVideoUploadWithoutEmbed: confirmVideoUploadWithoutEmbed
};
export default connect(mapStateToProps, mapDispatchToProps)(LimitsModalsContainer);